const CALENDLY_WIDGET_SRC = 'https://assets.calendly.com/assets/external/widget.js';

let loading = null;

// Loads Calendly's widget script (window.Calendly) the first time a component
// needs it. Loading it sends the visitor to Calendly, which sets a cookie, so
// it must not be part of every page.
export default function loadCalendlyWidget() {
    if (window.Calendly) {
        return Promise.resolve(window.Calendly);
    }

    loading ??= new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = CALENDLY_WIDGET_SRC;
        script.async = true;
        script.onload = () => resolve(window.Calendly);
        script.onerror = () => {
            loading = null;
            script.remove();
            reject(new Error('Calendly widget script failed to load'));
        };
        document.head.appendChild(script);
    });

    return loading;
}
